import { action, observable } from 'mobx';

import type { NotificationArgs } from 'types/notifications.types';
import BaseService from 'services/base-service';

export class NotificationStore extends BaseService {
  // `.ref`: a deep observable would clone a React element message into a proxy before antd renders it
  @observable.ref notification: NotificationArgs | null = null;

  @action setNotification(notification: NotificationArgs | null) {
    this.notification = notification;
  }
}
